import AccountBoxIcon from '@material-ui/icons/AccountBox'
import AspectRatio from '@material-ui/icons/AspectRatio'
import Assignment from '@material-ui/icons/Assignment'
import Brightness2 from '@material-ui/icons/Brightness2'
import Brightness7 from '@material-ui/icons/Brightness7'
import Business from '@material-ui/icons/Business'
import Description from '@material-ui/icons/Description'
import Dns from '@material-ui/icons/Dns'
import Flag from '@material-ui/icons/Flag'
import Group from '@material-ui/icons/Group'
import InsertChart from '@material-ui/icons/InsertChart'
import LanguageIcon from '@material-ui/icons/Language'
import LocalOffer from '@material-ui/icons/LocalOffer'
import LocalShipping from '@material-ui/icons/LocalShipping'
import LockIcon from '@material-ui/icons/Lock'
import Poll from '@material-ui/icons/Poll'
import React from 'react'
import SearchIcon from '@material-ui/icons/Search'
import Security from '@material-ui/icons/Security'
import SettingsIcon from '@material-ui/icons/SettingsApplications'
import ShowChart from '@material-ui/icons/ShowChart'
import Storage from '@material-ui/icons/Storage'
import StyleIcon from '@material-ui/icons/Style'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import ViewStream from '@material-ui/icons/ViewStream'
import Widgets from '@material-ui/icons/Widgets'
import Work from '@material-ui/icons/Work'
import allLocales from './locales'
import allThemes from './themes'
import getClient from '../utils/client'
import isClientGranted, { isAnyClientGranted } from '../utils/auth'

const getMenuItems = props => {
  const {
    locale,
    updateTheme,
    switchNightMode,
    updateLocale,
    intl,
    themeSource,
    isGranted,
    deferredPrompt,
    isAppInstallable,
    isAppInstalled,
    isAuthMenu,
    isAnyGranted,
    handleSignOut,
    history,
  } = props

  const client = getClient(props)

  const clientId = client && client.uid ? client.uid : '0'
  const isCGranted = g => isClientGranted(props, g)
  const isAnyCGranted = gs => isAnyClientGranted(props, gs)

  const themeItems = allThemes.map(t => {
    return {
      value: undefined,
      visible: true,
      primaryText: intl.formatMessage({ id: t.id }),
      onClick: () => {
        updateTheme(t.id)
      },
      leftIcon: <StyleIcon style={{ color: t.color }} />,
    }
  })

  const localeItems = allLocales.map(l => {
    return {
      value: undefined,
      visible: true,
      primaryText: intl.formatMessage({ id: l.locale }),
      onClick: () => {
        updateLocale(l.locale)
      },
      leftIcon: <LanguageIcon />,
    }
  })

  if (isAuthMenu) {
    return [
      {
        value: '/select_client?for=/',
        onClick: () => {
          history.push({
            pathname: '/select_client',
            search: 'for=/',
            state: { for: { pathname: '/' } },
          })
        },
        primaryText: intl.formatMessage({ id: 'select_client' }),
        leftIcon: <Work />,
      },
      {
        value: '/my_account',
        primaryText: intl.formatMessage({ id: 'my_account' }),
        leftIcon: <AccountBoxIcon />,
      },
      {
        value: '/signin',
        onClick: handleSignOut,
        primaryText: intl.formatMessage({ id: 'sign_out' }),
        leftIcon: <LockIcon />,
      },
    ]
  }

  return [
    {
      value: `/search/${clientId}`,
      //visible: false,
      visible: isCGranted('read_warehouse_tasks'),
      primaryText: intl.formatMessage({ id: 'search' }),
      leftIcon: <SearchIcon />,
    },
    {
      value: `/warehouse_tasks/${clientId}`,
      visible: isCGranted('read_warehouse_tasks'),
      primaryText: intl.formatMessage({ id: 'warehouse_tasks' }),
      leftIcon: <Assignment />,
    },
    {
      visible: isAnyCGranted(['read_stock']),
      primaryTogglesNestedList: true,
      primaryText: intl.formatMessage({ id: 'evaluation' }),
      leftIcon: <InsertChart />,
      nestedItems: [
        {
          value: `/stock/${clientId}`,
          visible: isCGranted('read_stock'),
          primaryText: intl.formatMessage({ id: 'stock' }),
          leftIcon: <ShowChart />,
        },
        {
          value: `/charge_report/${clientId}`,
          visible: isCGranted('read_charge_report'),
          primaryText: intl.formatMessage({ id: 'charge_report' }),
          leftIcon: <Description />,
        },
        {
          value: `/billing_report/${clientId}`,
          visible: isCGranted('read_biling_report'),
          primaryText: intl.formatMessage({ id: 'billing_report' }),
          leftIcon: <Poll />,
        },
      ],
    },

    {
      // value:'/base_data',
      visible:
        isAnyGranted(['read_warehouses', 'read_units']) ||
        isAnyCGranted(['read_items']),
      primaryTogglesNestedList: true,
      primaryText: intl.formatMessage({ id: 'base_data' }),
      leftIcon: <Storage />,
      nestedItems: [
        {
          value: '/warehouses',
          visible: isGranted('read_warehouses'),
          primaryText: intl.formatMessage({ id: 'warehouses' }),
          leftIcon: <Business />,
        },
        {
          value: `/items/${clientId}`,
          visible: isCGranted('read_items'),
          primaryText: intl.formatMessage({ id: 'items' }),
          leftIcon: <Widgets />,
        },
        {
          value: '/units',
          visible: isGranted('read_units'),
          primaryText: intl.formatMessage({ id: 'units' }),
          leftIcon: <AspectRatio />,
        },
        {
          value: `/trucks/${clientId}`,
          visible: isGranted('read_trucks'),
          primaryText: intl.formatMessage({ id: 'trucks' }),
          leftIcon: <LocalShipping />,
        },
        {
          value: `/trailers/${clientId}`,
          visible: isGranted('read_trailers'),
          primaryText: intl.formatMessage({ id: 'trailers' }),
          leftIcon: <ViewStream />,
        },
        {
          value: `/drivers/${clientId}`,
          visible: isGranted('read_drivers'),
          primaryText: intl.formatMessage({ id: 'drivers' }),
          leftIcon: <Group />,
        },
      ],
    },

    {
      // value:'/base_data',
      visible:
        isAnyGranted(['read_document_types']) ||
        isAnyCGranted(['read_task_types', 'read_warehouse_task_workflows']),
      primaryTogglesNestedList: true,
      primaryText: intl.formatMessage({ id: 'datamanagement' }),
      leftIcon: <Dns />,
      nestedItems: [
        {
          value: '/document_types',
          visible: isGranted('read_document_types'),
          primaryText: intl.formatMessage({ id: 'document_types' }),
          leftIcon: <Business />,
        },
        {
          value: `/task_types/${clientId}`,
          visible: isCGranted('read_task_types'),
          primaryText: intl.formatMessage({ id: 'task_types' }),
          leftIcon: <LocalOffer />,
        },
        {
          value: `/warehouse_task_workflows/${clientId}`,
          visible: isCGranted('read_warehouse_task_workflows'),
          primaryText: intl.formatMessage({ id: 'warehouse_task_workflows' }),
          leftIcon: <Flag />,
        },
      ],
    },
    {
      divider: true,
    },
    {
      visible: isGranted('administration'),
      primaryTogglesNestedList: true,
      primaryText: intl.formatMessage({ id: 'administration' }),
      leftIcon: <Security />,
      nestedItems: [
        {
          value: '/clients',
          visible: isGranted('read_clients'),
          primaryText: intl.formatMessage({ id: 'clients' }),
          leftIcon: <Work />,
        },
        {
          value: '/users',
          visible: isGranted('read_users'),
          primaryText: intl.formatMessage({ id: 'users' }),
          leftIcon: <Group />,
        },
        {
          value: '/roles',
          visible: isGranted('read_roles'),
          primaryText: intl.formatMessage({ id: 'roles' }),
          leftIcon: <AccountBoxIcon />,
        },
      ],
    },
    {
      primaryText: intl.formatMessage({ id: 'settings' }),
      primaryTogglesNestedList: true,
      leftIcon: <SettingsIcon />,
      nestedItems: [
        {
          primaryText: intl.formatMessage({ id: 'theme' }),
          secondaryText: intl.formatMessage({ id: themeSource.source }),
          primaryTogglesNestedList: true,
          leftIcon: <StyleIcon />,
          nestedItems: themeItems,
        },
        {
          primaryText: intl.formatMessage({ id: 'language' }),
          secondaryText: intl.formatMessage({ id: locale }),
          primaryTogglesNestedList: true,
          leftIcon: <LanguageIcon />,
          nestedItems: localeItems,
        },
      ],
    },
    {
      onClick: () => {
        switchNightMode(!themeSource.isNightModeOn)
      },
      primaryText: intl.formatMessage({
        id: themeSource.isNightModeOn ? 'day_mode' : 'night_mode',
      }),
      leftIcon: themeSource.isNightModeOn ? <Brightness7 /> : <Brightness2 />,
    },
    {
      visible: isAppInstallable && !isAppInstalled,
      onClick: () => {
        deferredPrompt.prompt()
      },
      primaryText: intl.formatMessage({ id: 'install' }),
      leftIcon: <VerticalAlignBottomIcon />,
    },
  ]
}

export default getMenuItems
